// extracted by mini-css-extract-plugin
module.exports = {"minimumEnvText":"style_minimumEnvText__36NJQ","minCompleteLabel":"style_minCompleteLabel__38K5K"};